import React from "react";
import { inr } from "../../lib/api";

// Tier-by-tier goods fare breakdown (from ride.fare_breakdown / goods_fare_components).
export default function GoodsFareBreakdown({ breakdown }) {
  if (!breakdown || !breakdown.tiers) return null;
  return (
    <div className="mt-4 rounded-2xl border border-surface-300 bg-surface-50 p-4" data-testid="history-goods-breakdown">
      <p className="mb-2 text-xs font-bold uppercase tracking-wider text-ink-muted">Fare breakdown · {breakdown.billed_km} km</p>
      <div className="space-y-1 text-sm">
        <div className="flex justify-between"><span className="text-ink-soft">Base fare (first km)</span><span className="font-semibold text-ink">{inr(breakdown.base)}</span></div>
        <div className="flex justify-between"><span className="text-ink-soft">Distance ({breakdown.charged_km} km, tapered)</span><span className="font-semibold text-ink">{inr(breakdown.distance_charge)}</span></div>
        <div className="flex justify-between"><span className="text-ink-soft">Time ({breakdown.duration_min} min)</span><span className="font-semibold text-ink">{inr(breakdown.time_charge)}</span></div>
        <div className="mt-1 flex justify-between border-t border-surface-300 pt-2 text-base"><span className="font-bold text-ink">Total</span><span className="font-bold text-brand">{inr(breakdown.fare)}</span></div>
      </div>
      <p className="mt-2 text-[11px] leading-relaxed text-ink-muted">Longer trips are charged less per km: {breakdown.tiers.map((t) => `≤${t.upto_km}km ${t.rate_pct}%`).join(" · ")}</p>
    </div>
  );
}
